
interface UIBlock {
    name: string;
    script: string;
    imageUrl: string;
}

const defaultBlocks: UIBlock[] = [{
    name: 'Heading',
    script: '<div data-type="draggable-node" class="header-wrapper"><h2><strong>Heading<strong></h2></div>',
    imageUrl: 'images/enhanced-content/heading.png'
}, {
    name: 'Description',
    script: '<div data-type="draggable-node"><p>This is a custom design element for applying unique text styles. Please read carefully to understand how to use it.</p></div>',
    imageUrl: 'images/enhanced-content/description.png'
}, {
    name: 'Image',
    script: '<div data-type="draggable-node"><img width="100%" /></div>',
    imageUrl: 'images/enhanced-content/image.png'
}, {
    name: 'Left aligned image with a description',
    script:
        `<div data-type="draggable-node">
            <div style='display: grid; grid-template-columns: repeat(2, minmax(0, 1fr));' data-type='two-columns'>
                <div data-type="single-column">
                    <img width="100%" src="https://placehold.co/600x400" />
                </div>
                <div data-type="single-column">
                    <p>This is a custom design element for applying unique text styles. Please read carefully to understand how to use it.</p>
                </div>
            </div>
        </div>`,
    imageUrl: 'images/enhanced-content/image-left-and-description.png'
}, {
    name: 'Right aligned image with a description',
    script:
        `<div data-type="draggable-node">
            <div style='display: grid; grid-template-columns: repeat(2, minmax(0, 1fr));' data-type='two-columns'>
                <div data-type="single-column">
                    <p>This is a custom design element for applying unique text styles. Please read carefully to understand how to use it.</p>
                </div>
                <div data-type="single-column">
                    <img width="100%" src="https://placehold.co/600x400" />
                </div>
            </div>
        </div>`,
    imageUrl: 'images/enhanced-content/image-right-and-description.png'
}, {
    name: 'Three images and a description',
    script:
        `<div data-type="draggable-node">
            <div style='display: grid; grid-template-columns: repeat(3, minmax(0, 1fr));' data-type='three-columns'>
                <div data-type="single-column">
                    <img width="100%" src="https://placehold.co/600x400" />
                    <p>This is a custom design element for applying unique text styles. Please read carefully to understand how to use it.</p>
                </div>
                <div data-type="single-column">
                    <img width="100%" src="https://placehold.co/600x400" />
                    <p>This is a custom design element for applying unique text styles. Please read carefully to understand how to use it.</p>
                </div>
                <div data-type="single-column">
                    <img width="100%" src="https://placehold.co/600x400" />
                    <p>This is a custom design element for applying unique text styles. Please read carefully to understand how to use it.</p>
                </div>
            </div>
        </div>`,
    imageUrl: 'images/enhanced-content/three-images-and-description.png'
},{
    name: 'Video',
    script: `<video controls width="100%" controls>
            <source src="path/to/video.mp4" type="video/mp4">
            <source src="path/to/video.webm" type="video/webm">
            <source src="path/to/video.ogg" type="video/ogg">
            <source src="path/to/video.ogg" type="video/quicktime">
            Your browser does not support the video tag.
        </video>`,
    imageUrl: 'images/enhanced-content/placeholder-video.png'
}];

export { defaultBlocks, type UIBlock };
